import React, { useCallback, useEffect, useState } from "react";
import {
  Modal,
  Button,
  Input,
  Form,
  message,
  Row,
  Col,
} from "antd";

import { http } from "../../../utils/config";
// import { debounce } from "lodash";
// import OTPModal from "../../User/OTPModal";
import { errorMessage } from "../../../lib/apiError";
import { checkOTP, generaOTP } from "../../../api/User/editUser";
import { useSession } from "../../../auth/session";

const GiftExchangeModal = ({
  visible,
  gift,
  onClose,
  onConfirm,
  isLoading,
}) => {
  const { user } = useSession();

  const [form] = Form.useForm();
  const [requireOTP, setRequireOTP] = useState(false);
  const [telco, setTelco] = useState(null);
  const [phoneCus, setPhoneCus] = useState(user?.data?.phone);
  const [countdown, setCountdown] = useState(0);
  const [loadgeneraOtp, setLoadgeneraOtp] = useState();
  const [isVerified, setIsVerified] = useState(false);
  const [isShowGift, setShowGift] = useState(false);

  const fetchData = async (phone) => {
    try {
      const apiUrl = `/api/v1/serviceconnect/gift-exchange-for-customers/get-phone-and-telco?phone=${phone}`;
      const res = await http.get(apiUrl);

      const { telco, phone: returnedPhone } = res?.data?.data || {};
      setTelco(telco);
      form.setFieldsValue({ phone: returnedPhone || phone });
      // generateOtp();
    } catch (error) {
      console.error("Lỗi khi gọi API:", error);
      message.error("Không thể lấy thông tin nhà mạng. Vui lòng thử lại!");
    }
  };

  const handleSearch = async (phone) => {
    await fetchData(phone);
    // if (normalizePhone(phone) === normalizePhone(user?.data?.phone)) {
    //   setRequireOTP(false);
    //   setShowGift(true);
    // } else {
    //   setRequireOTP(true);
    //   setShowGift(false);
    // }
    setRequireOTP(true);
    setShowGift(false);
  };

  const normalizePhone = (phone) => {
    if (!phone) return null;
    return phone.startsWith("0") ? `84${phone.slice(1)}` : phone;
  };

  const handleConfirm = async () => {
    try {
      const values = await form.validateFields();

      if (gift.type === "DATA" && !isVerified && (normalizePhone(phoneCus) !== normalizePhone(user?.data?.phone))) {
        message.error("Vui lòng xác nhận OTP trước khi tiếp tục.");
        return;
      }

      // if(gift.type === "DATA"){
      //   const dataPost = {
      //     phone: phoneCus
      //   };
      // }

      const dataPost = (gift.type === "DATA") ? {phone: phoneCus} : {name: values.name, phone: values.phone, address: values.address};
      
      onConfirm(dataPost);
    } catch (err) {
      console.error("Validation failed:", err);
    }
  };

  const phoneChangeIpt = (e) => {
    setPhoneCus(e.target.value.trim());
  };

  useEffect(() => {
    fetchData(phoneCus);
    // generateOtp();
    // setShowGift(true);
    setRequireOTP(true);

    if (gift.type === "DATA"){
      setRequireOTP(true);
    }else{
      setShowGift(true);
      setRequireOTP(false);
    }
  }, []);

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);

  const generateOtp = useCallback(async () => {
    const data = {
      phone: user?.data?.phone,
      action: "update-auth",
      branch_id: gift?.mcoupon_branch_id,
    };
    setLoadgeneraOtp(true);
    try {
      const response = await generaOTP(data);
      if (response?.status === true) {
        setCountdown(60);
        message.success("Đã gửi mã OTP thành công!");
      } else {
        message.error(response?.message || "Gửi mã OTP thất bại");
      }
    } catch (error) {
      message.error(errorMessage(error, "Có lỗi xảy ra. Vui lòng thử lại sau!"));
    } finally {
      setLoadgeneraOtp(false);
    }
  }, [form]);

  const handleVerify = async (e) => {
    try {
      const values = await form.validateFields();
      const otp = values.otp;

      const data = {
        phone: user?.data?.phone,
        token: otp,
        action: "update-auth",
      };

      try {
        const response = await checkOTP(data);
        if (response?.status === true) {
          setIsVerified(true);
          setShowGift(true);
          // await handleConfirm();
          message.success("Xác thực mã OTP thành công!");
          setCountdown(0);
        } else if (response?.message === "OTP does not match") {
          message.error("Mã OTP không khớp");
        } else if (response?.message === "OTP is expired") {
          message.error("Mã OTP đã hết hạn");
        } else {
          message.error("Đã vượt quá số lần thử vui lòng thử lại sau 3 phút");
        }
      } catch (error) {
        message.error(errorMessage(error));
      }
    } catch (err) {
      console.error("Validation failed:", err);
    }
  };

  return (
    <Modal
      title={`Xác nhận đổi quà: ${gift?.name}`}
      visible={visible}
      onOk={handleConfirm}
      onCancel={onClose}
      confirmLoading={isLoading}
      okText="Đổi quà"
      cancelText="Hủy"
      okButtonProps={{ disabled: !isShowGift }}
    >
      {gift.type === "PRODUCT" ? (
        <Form form={form} layout="vertical">
          <Form.Item
            label="Họ và tên"
            name="name"
            rules={[{ required: true, message: "Vui lòng nhập họ và tên!" }]}
          >
            <Input placeholder="Nhập họ và tên" />
          </Form.Item>
          <Form.Item
            label="Số điện thoại"
            name="phone"
            rules={[
              { required: true, message: "Vui lòng nhập số điện thoại!" },
            ]}
          >
            <Input placeholder="Nhập số điện thoại" />
          </Form.Item>
          <Form.Item
            label="Địa chỉ nhận hàng"
            name="address"
            rules={[
              { required: true, message: "Vui lòng nhập địa chỉ nhận hàng!" },
            ]}
          >
            <Input.TextArea placeholder="Nhập địa chỉ nhận hàng" />
          </Form.Item>
        </Form>
      ) : gift.type === "DATA" ? (
        <Form form={form} layout="vertical">
          <Form.Item
            label="Số điện thoại nhận data"
            name="phone"
            rules={[
              {
                required: true,
                message: "Vui lòng nhập số điện thoại",
              },
              {
                pattern: /^(84|0)[0-9]{9}$/,
                message: "Số điện thoại chưa đúng định dạng!",
              },
            ]}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ width: "30%", textAlign: "center" }}>
                {telco || "Không xác định"}
              </div>
              <div style={{ width: "70%" }}>
                <Input
                  name="phone"
                  placeholder="Số điện thoại"
                  onChange={(e) => {
                    phoneChangeIpt(e);
                    form.setFieldValue(e.target.value.trim());
                    if (
                      e.target.value
                        .trim()
                        .toString()
                        .match(/^(84|0)[0-9]{9}$/)
                    ) {
                      handleSearch(e.target.value.trim());
                    }
                  }}
                  value={phoneCus}
                />
              </div>
            </div>
          </Form.Item>
          {requireOTP && (
            <>
              <Row gutter={16}>
                <Col xs={24} sm={12} span={17}>
                  <Form.Item
                    name="otp"
                    rules={[
                      { required: true, message: "Vui lòng nhập mã OTP!" },
                    ]}
                  >
                    <Input placeholder="Nhập mã OTP" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} span={7}>
                  <Button
                    type="primary"
                    block
                    onClick={countdown > 0 ? handleVerify : generateOtp}
                    loading={loadgeneraOtp && countdown <= 0}
                  >
                    {countdown > 0 ? "Xác minh" : "Gửi OTP"}
                  </Button>
                </Col>
              </Row>

              {countdown > 0 && (
                <div style={{ textAlign: "right", marginBottom: 16 }}>
                  <span>Mã OTP sẽ hết hạn trong {countdown} giây</span>
                </div>
              )}
            </>
          )}
        </Form>
      ) : null}
    </Modal>
  );
};

export default GiftExchangeModal;
